import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import classes from './CoevaluationInstructions.module.css';

const CoevaluationInstructions = props => {
  const { t } = useTranslation(['lesson']);
  return (
    <>
      <div className={classes.activityContainer}>
        <aside className={classes.instructionsContainer}>
          <p className={classes.instructions__title}>
            {t('instructions')}:
          </p>
          <ol>
            <li className={classes.instructions__text}>
              {t('click_continue')}
            </li>
            <li className={classes.instructions__text}>
              {t('click_see_content')}
            </li>
            <li className={classes.instructions__text}>
              {t('click_empty_field')}
            </li>
            <li className={classes.instructions__text}>
              {t('feedback_comment')}
            </li>
          </ol>
        </aside>
      </div>
      <aside className={classes.btnsContainer}>
        <Button
          onClick={props.changeViewHandler}
          className={classes.nextBtn}
        >
          {t('continue')} <ChevronRightIcon />
        </Button>
      </aside>
    </>
  );
};

CoevaluationInstructions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  changeViewHandler: PropTypes.func
};

export default CoevaluationInstructions;
